import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=1a4e17a2"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=1a4e17a2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4e17a2')) {
      api.createRecord('1a4e17a2', component.options)
    } else {
      api.reload('1a4e17a2', component.options)
    }
    module.hot.accept("./framework.vue?vue&type=template&id=1a4e17a2", function () {
      api.rerender('1a4e17a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyManage/framework.vue"
export default component.exports